/**
 * `useAuth` hook split out of AuthContext.tsx so the provider file only
 * exports React components — required for Vite's React Fast Refresh.
 */
import { useContext } from 'react';
import { AuthContext } from './auth-context';

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used inside AuthProvider');
  return ctx;
}
